<label [class.isChecked]="_parent.value && value === _parent.value" role="button" tabindex="0">
    <input type="radio" tabindex="-1" [name]="_parent.name" [value]="value" [(ngModel)]="_parent.value" />
    <span [ngStyle]="{ 'background-image': backgroundImage }" class="color-swatch">
        <mg-ui-checkmark></mg-ui-checkmark>
    </span>
</label>
